import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import { useLocation } from 'react-router-dom';
import { MdKeyboardArrowDown } from 'react-icons/md';
import { useStyles } from "./styles";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Box, Button } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import ClickAwayListener from 'react-click-away-listener';
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import FR from "../../assets/images/FR.png";
// import GB from "../../assets/images/GB.png";
import SA from "../../assets/images/SA.png";
import { setIsOpen } from "../../actions/modalActions";
import { AppState } from "../../reducers";
import { setIntl } from "../../actions/intlAction";
import { setIsBusy } from "../../actions/busyActions";

export default function Header() {
  const classes = useStyles();

  const { t, i18n } = useTranslation();

  const [imgFlag, setFlag] = useState<any>();

  const [lang, setLang] = useState<any>();

  const [pageTitle, setPageTitle] = useState('');

  const location = useLocation();

  const typeForm = location?.state?.form;

  const dispatch = useDispatch();

  const [openBtnPopup, setOpenBtnPopup] = React.useState(false);

  const [openBtnPopup2, setOpenBtnPopup2] = React.useState(false);

  const { profile } = useSelector((state: AppState) => state.profile);

  const { intl } = useSelector((state: AppState) => state.intl);

  const handleOpen = () => {
    dispatch(setIsOpen(true));
  };

  const handleClick = () => {
    setOpenBtnPopup((prev) => !prev);
  };

  const handleClickAway = () => {
    setOpenBtnPopup(false);
  };

  const handleClick2 = () => {
    setOpenBtnPopup2((prev) => !prev);
  };

  const handleClickAway2 = () => {
    setOpenBtnPopup2(false);
  };

  useEffect(() => {
    if (location.pathname.includes('vehicle'))
      setPageTitle(String(t("vehicules")));
    else if (location.pathname.includes('driver'))
      setPageTitle(String(t("drivers")));
    else if (location.pathname.includes('profil') || typeForm === 'addDriver') {
      setPageTitle(String(t("drivers")));
    } else if (typeForm === 'addVehicle') {
      setPageTitle(String(t("vehicules")));
    } else
      switch (location.pathname) {
        case '/performance':
          setPageTitle(String(t("performance")));
          break;
        case '/chauffeurs':
          setPageTitle(String(t("drivers")));
          break;
        case '/vehicules':
          setPageTitle(String(t("vehicules")));
          break;
        case '/revenues':
          setPageTitle(String(`<span style='color: #AFAAC2; text-transform: capitalize;'>${(t("accounts"))} > </span>${t("earnings")}`));
          break;
        case '/paiements':
          // setPageTitle( intl !== 'ar' ?
          //   String(`<span style='color: #AFAAC2; text-transform: capitalize;'>${(t("accounts"))} > </span>${t("payments")}`) : 
          //   String(`${t("payments")}<span style='color: #AFAAC2; text-transform: capitalize;'> < ${(t("accounts"))}</span>`)
          //   );
          setPageTitle(String(`<span style='color: #AFAAC2; text-transform: capitalize;'>${(t("accounts"))} > </span>${t("payments")}`));
          break;
        default:
          break;
      }

  }, [location, t, typeForm, intl])

  const switchLang = (lang: any) => {
    dispatch(setIsBusy(null))
    dispatch(setIntl(lang));
    i18n.changeLanguage(lang);
    setOpenBtnPopup2(false);
    switch (lang) {
      case 'ar':
        setFlag(SA);
        setLang(t('arabic'));
        break;
      // case 'en':
      //   setFlag(GB);
      //   setLang(t('english'))
      //   break;
      default:
        setFlag(FR);
        setLang(t('french'))
        break;
    }
    localStorage.setItem('fleetLangage', lang);
  }

  useEffect(() => {
    switch (String(intl)) {
      case 'ar':
        setFlag(SA);
        setLang(t('arabic'));
        break;
      // case 'en':
      //   setFlag(GB);
      //   setLang(t('english'))
      //   break;
      default:
        setFlag(FR);
        setLang(t('french'))
        break;
    }
  }, [intl, t])

  return (
    <>
      <Grid container spacing={1} className={classes.top_bar}>
        <Grid item xs={4} sm={4} md={profile?.fleetOwnerProfile?.fullName.length > 20 ? 6 : 8} lg={profile?.fleetOwnerProfile?.fullName.length > 20 ? 8 : 9} className={intl === 'ar' ? classes.page_title_ar : classes.page_title} dangerouslySetInnerHTML={{ __html: pageTitle }} />
        <Grid item xs={4} sm={4} md={profile?.fleetOwnerProfile?.fullName.length > 20 ? 3 : 2} lg={profile?.fleetOwnerProfile?.fullName.length > 20 ? 2 : 1.5}>
          <ClickAwayListener onClickAway={handleClickAway2}>
            <Grid className={classes.profil_menu} style={{ float: intl === 'ar' ? 'right' : 'left', margin: '5px 0px 0px 0px' }}>
              <Box
                className={classes.lang_selected}
                onClick={handleClick2}
                data-testid="profile-button"
              >
                <div className={classes.ctn_text_lang_selected} style={{ margin: imgFlag === SA ? '0px 5px 0px 15px' : '0px 15px 0px 5px', }}>
                  <table>
                    <tr>
                      {/* <td>
                        <img src={imgFlag || FR} alt='' style={{ marginBottom: intl === 'ar' ? '5px' : '0px' }} />
                      </td> */}
                      <td>
                        <h3 className={classes.text_lang_selected} style={{ margin: intl === 'ar' ? '3px 0px 8px 5px' : '5px 0px 8px 5px', fontFamily: intl === 'ar' ? 'TheSansArab' : 'Gellix' }}>
                          {lang || t('french')}
                        </h3>
                      </td>
                      <td>
                        <MdKeyboardArrowDown style={
                          intl === 'ar' ?
                            {
                              margin: '-3px 30px 0px 0px',
                              fontSize: '20px',
                              transform: openBtnPopup2 ? 'rotate(180deg)' : 'rotate(0deg)',
                            } :
                            {
                              margin: '0px 0px 0px 18px',
                              fontSize: '20px',
                              transform: openBtnPopup2 ? 'rotate(180deg)' : 'rotate(0deg)',
                            }
                        } />
                      </td>
                    </tr>
                  </table>
                </div>
              </Box>
              {openBtnPopup2 &&
                <div className={classes.ctnMenuLang} style={{ direction: 'ltr', margin: '5px 0px 0px -10px', }}>
                  <div className={classes.elemLang} onClick={() => { switchLang('fr') }} style={intl === 'ar' ? { alignItems: 'end', padding: "0px 8px 0px 0px" } : { alignItems: 'start', padding: "0px 0px 0px 8px" }}>
                    <table >
                      <tr>
                        {/* <td>
                          <img src={FR} alt='' />
                        </td> */}
                        <td>
                          <h3 className={classes.text_lang_selected}>
                            {t('french')}
                          </h3>
                        </td>
                      </tr>
                    </table>
                  </div>
                  {/* <div className={classes.elemLang} onClick={() => { switchLang('en') }} style={{ padding: intl === 'ar' ? "0px 8px 0px 0px" : "0px 0px 0px 8px", }}>
                    <table >
                      <tr>
                        <td>
                          <img src={GB} alt='' />
                        </td>
                        <td>
                          <h3 className={classes.text_lang_selected}>
                            {t('english')}
                          </h3>
                        </td>
                      </tr>
                    </table>
                  </div> */}
                  <div className={classes.elemLang} onClick={() => { switchLang('ar') }} style={intl === 'ar' ? { alignItems: 'end', padding: "0px 8px 0px 0px" } : { alignItems: 'start', padding: "0px 0px 0px 8px" }}>
                    <table >
                      <tr>
                        <td>
                          <h3 className={classes.text_lang_selected} style={{ fontFamily: 'TheSansArab' }}>
                            {t('arabic')}
                          </h3>
                        </td>
                        {/* <td>
                          <img src={SA} alt='' />
                        </td> */}
                      </tr>
                    </table>
                  </div>
                </div>
              }
            </Grid>
          </ClickAwayListener>
        </Grid>
        <Grid item xs={4} sm={4} md={profile?.fleetOwnerProfile?.fullName.length > 20 ? 3 : 2} lg={profile?.fleetOwnerProfile?.fullName.length > 20 ? 2 : 1.5}>
          <ClickAwayListener onClickAway={handleClickAway}>
            <Grid className={classes.profil_menu}>
              <Grid>
                <Box
                  className={classes.profil_infos}
                  onClick={handleClick}
                  data-testid="profile-button"
                >
                  <Box className={classes.text_field}>
                    <h3 className={classes.usr_name}>
                      {profile?.fleetOwnerProfile?.fullName}
                    </h3>
                  </Box>
                  <PersonOutlineOutlinedIcon
                    className={classes.user_avatar}
                    data-testid="profile-icon"
                  ></PersonOutlineOutlinedIcon>
                </Box>
              </Grid>
              <Grid>
                {openBtnPopup ? (
                  <Button
                    data-testid="logout-button"
                    style={{
                      flexDirection: "row",
                      gap: "8px",
                      justifyContent: "space-between",
                      margin: "5% 3%",
                      padding: "8px",

                      backgroundColor: "#FFF",
                      borderRadius: "4px",
                      color: "#1A0244",
                      fontFamily: intl === 'ar' ? 'TheSansArab' : 'Gellix',
                      fontWeight: intl === 'ar' ? 600 : 500,
                      fontSize: intl === 'ar' ? '15px' : '14px',
                      border: "solid #CED4E5 O.5px",
                      textTransform: "capitalize",
                      zIndex: 5,
                    }}
                    className={classes.logout_btn}
                    onClick={() => {
                      handleOpen();
                    }}
                  >
                    <LogoutIcon
                      sx={{
                        color: "#1A0244",
                        height: "20px",
                        width: "20px",
                        transform: intl === 'ar' ? 'rotate(180deg)' : 'rotate(0deg)',
                      }}
                    />
                    {t("logout")}
                  </Button>
                ) : (
                  ""
                )}
              </Grid>
            </Grid>
          </ClickAwayListener>
        </Grid>
      </Grid>
      <div style={{ height: '25px' }} />
    </>
  );
}
